import React, {Component} from 'react';
import {Select, Form, Button, DatePicker} from 'antd';
import moment from 'moment';
import _ from 'underscore';
import locale from 'antd/lib/date-picker/locale/zh_CN';
import PropTypes from 'prop-types';
import {api, app} from "../app";

const FormItem = Form.Item;
const Option = Select.Option;

class bigDataFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            provinceList: [],
            teamList: [],
            rights: app.getData('rights'),
        };
    }

    async setData(data) {
        await app.setStateSync(this, data);
    }

    async componentDidMount() {
        this._isMounted = true;
        let {rights} = this.state;
        let {hasDate, form} = this.props;
        let {setFieldsValue} = form;
        let sign_rights = await this.signRights();
        let type = 1;
        let mark = '全国';
        let teamname = '全国';
        if (rights === 1 || sign_rights === 1) {
            await this.provinceData();
            setFieldsValue({province: '0'});
        } else if (rights === 2) {
            await this.provinceData();
            let {provinceList} = this.state;
            mark = provinceList[0].area_name;
            type = 2;
            teamname = mark;
            setFieldsValue({province: mark, team: '0'});
            await this.teamData(mark);
        } else if (rights === 3) {
            await this.teamData();
            let {teamList} = this.state;
            mark = teamList[0].teamno;
            teamname = teamList[0].teamname;
            type = 3;
            setFieldsValue({team: mark});
        }
        let result = {type, mark, teamname};
        if (hasDate) {
            let now = moment();
            result.start_time = now.format("YYYY-MM-DD");
            result.end_time = now.format("YYYY-MM-DD");
            setFieldsValue({date: [now,now]});
        }
        this.props.change(result);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * 签到权限
     * @returns {Promise<number>}
     */
    signRights = async () => {
        let params = {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        };
        const {flag, data = 0, msg} = await app.post(api.SinginDataPermission, params);
        if (flag === 1) {
            app.setData('sign_rights', data);
            await this.setData({sign_rights: data});
            return data;
        } else {
            app.alert(msg, "error");
        }
        return 0;
    }

    /**
     * 省份数据
     * @returns {Promise<void>}
     */
    provinceData = async () => {
        let params = {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        };
        let {flag, data, msg} = await app.post(api.ScreenProvinceList, params);
        if (flag === 1) {
            await this.setData({provinceList: data});
        } else {
            app.alert(msg, "error");
        }
    }

    /**
     * 队伍数据
     * @returns {Promise<void>}
     */
    teamData = async (province) => {
        const {setFieldsValue} = this.props.form;
        if (province === '0') {
            await this.setData({teamList: []});
            setFieldsValue({team: undefined});
        } else {
            let params = {
                indexno: app.getData("indexno"),
                account: app.getData("account"),
            };
            if (province) params.province = province;
            let {flag, data, msg} = await app.post(api.ScreenProvinceTeamList, params);
            if (flag === 1) {
                await this.setData({teamList: data});
                setFieldsValue({team: '0'});
            } else {
                app.alert(msg, "error");
            }
        }
    }

    /**
     * 提交
     * @param e
     */
    handleSubmit = (e) => {
        e.preventDefault();
        let {form, hasDate} = this.props;
        form.validateFields((err, {date, province, team}) => {
            if (!err) {
                let result = {
                    type: 1,
                    mark: '全国',
                    teamname: '全国',
                };
                if (hasDate && date) {
                    result.start_time = date[0].format('YYYY-MM-DD');
                    result.end_time = date[1].format('YYYY-MM-DD');
                }
                if (province === '0') {
                    //全国
                } else if (province && team === '0') {
                    //全省
                    result.type = 2;
                    result.mark = province;
                    result.teamname = province;
                } else if (team) {
                    //队伍
                    result.type = 3;
                    result.mark = team;
                    let {teamList} = this.state;
                    let tn = _.find(teamList, ({teamno}) => teamno === team) || {};
                    result.teamname = tn.teamname;
                }
                this.props.change(result);
            }
        });
    }

    render() {
        let {provinceList, teamList, rights, sign_rights} = this.state,
            {hasDate, form} = this.props,
            {getFieldDecorator, getFieldValue} = form;
        return (
            <Form layout="inline" style={{textAlign: "right"}} onSubmit={this.handleSubmit}>
                {
                    hasDate ? (
                        <FormItem
                            label="日期筛选"
                            style={{textAlign: "left"}}
                        >
                            {getFieldDecorator('date')(
                                <DatePicker.RangePicker locale={locale} disabledDate={(current) => {
                                    return current && (current < moment('2018-07-31').endOf('day') || current > moment().endOf('day'));
                                }}/>
                            )}
                        </FormItem>
                    ) : null
                }
                {
                    '12'.indexOf(rights) !== -1 ||  sign_rights === 1 ? (
                        <FormItem
                            label="队伍筛选"
                        >
                            {getFieldDecorator('province')(
                                <Select style={{width: 120, margin: '0 20rpx'}} placeholder="选择省份"
                                        onChange={this.teamData}>
                                    {
                                        rights === 1 || sign_rights === 1 ? (
                                            <Option value="0">全国</Option>
                                        ) : null
                                    }
                                    {
                                        provinceList.map((pro, i) => {
                                            return (
                                                <Option key={i} value={pro.area_name}>{pro.area_name}</Option>
                                            );
                                        })
                                    }
                                </Select>
                            )}
                        </FormItem>
                    ) : null
                }
                <FormItem>
                    {getFieldDecorator('team')(
                        <Select style={{width: 240}} placeholder="选择队伍" disabled={getFieldValue('province') === '0'}>
                            {
                                '12'.indexOf(rights) !== -1 ||  sign_rights === 1 ? (
                                    <Option value="0">全省</Option>
                                ) : null
                            }
                            {
                                teamList.map((team, i) => {
                                    return (
                                        <Option key={i} value={team.teamno}>{team.teamname}</Option>
                                    );
                                })
                            }
                        </Select>
                    )}
                </FormItem>
                <FormItem>
                    <Button
                        type="primary"
                        htmlType="submit"
                    >
                        搜索
                    </Button>
                </FormItem>
            </Form>
        );
    }
}

bigDataFilter.propTypes = {
    hasDate: PropTypes.any,
    change: PropTypes.func.isRequired,
}

export default Form.create()(bigDataFilter);



// WEBPACK FOOTER //
// ./src/components/BigDataFilter.jsx